/**
 * @fileoverview gRPC-Web generated client stub for acompanha.jobs.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.2
// source: acompanha/jobs/v1/jobs.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.acompanha = {};
proto.acompanha.jobs = {};
proto.acompanha.jobs.v1 = require('./jobs_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.jobs.v1.JobsServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.jobs.v1.JobsServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.jobs.v1.ListJobsRequest,
 *   !proto.acompanha.jobs.v1.ListJobsResponse>}
 */
const methodDescriptor_JobsService_ListJobs = new grpc.web.MethodDescriptor(
  '/acompanha.jobs.v1.JobsService/ListJobs',
  grpc.web.MethodType.UNARY,
  proto.acompanha.jobs.v1.ListJobsRequest,
  proto.acompanha.jobs.v1.ListJobsResponse,
  /**
   * @param {!proto.acompanha.jobs.v1.ListJobsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.jobs.v1.ListJobsResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.jobs.v1.ListJobsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.jobs.v1.ListJobsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.jobs.v1.ListJobsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.jobs.v1.JobsServiceClient.prototype.listJobs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.jobs.v1.JobsService/ListJobs',
      request,
      metadata || {},
      methodDescriptor_JobsService_ListJobs,
      callback);
};


/**
 * @param {!proto.acompanha.jobs.v1.ListJobsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.jobs.v1.ListJobsResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.jobs.v1.JobsServicePromiseClient.prototype.listJobs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.jobs.v1.JobsService/ListJobs',
      request,
      metadata || {},
      methodDescriptor_JobsService_ListJobs);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.jobs.v1.GetJobRequest,
 *   !proto.acompanha.jobs.v1.GetJobResponse>}
 */
const methodDescriptor_JobsService_GetJob = new grpc.web.MethodDescriptor(
  '/acompanha.jobs.v1.JobsService/GetJob',
  grpc.web.MethodType.UNARY,
  proto.acompanha.jobs.v1.GetJobRequest,
  proto.acompanha.jobs.v1.GetJobResponse,
  /**
   * @param {!proto.acompanha.jobs.v1.GetJobRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.jobs.v1.GetJobResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.jobs.v1.GetJobRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.jobs.v1.GetJobResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.jobs.v1.GetJobResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.jobs.v1.JobsServiceClient.prototype.getJob =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.jobs.v1.JobsService/GetJob',
      request,
      metadata || {},
      methodDescriptor_JobsService_GetJob,
      callback);
};


/**
 * @param {!proto.acompanha.jobs.v1.GetJobRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.jobs.v1.GetJobResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.jobs.v1.JobsServicePromiseClient.prototype.getJob =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.jobs.v1.JobsService/GetJob',
      request,
      metadata || {},
      methodDescriptor_JobsService_GetJob);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.jobs.v1.CreateJobRequest,
 *   !proto.acompanha.jobs.v1.CreateJobResponse>}
 */
const methodDescriptor_JobsService_CreateJob = new grpc.web.MethodDescriptor(
  '/acompanha.jobs.v1.JobsService/CreateJob',
  grpc.web.MethodType.UNARY,
  proto.acompanha.jobs.v1.CreateJobRequest,
  proto.acompanha.jobs.v1.CreateJobResponse,
  /**
   * @param {!proto.acompanha.jobs.v1.CreateJobRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.jobs.v1.CreateJobResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.jobs.v1.CreateJobRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.jobs.v1.CreateJobResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.jobs.v1.CreateJobResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.jobs.v1.JobsServiceClient.prototype.createJob =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.jobs.v1.JobsService/CreateJob',
      request,
      metadata || {},
      methodDescriptor_JobsService_CreateJob,
      callback);
};


/**
 * @param {!proto.acompanha.jobs.v1.CreateJobRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.jobs.v1.CreateJobResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.jobs.v1.JobsServicePromiseClient.prototype.createJob =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.jobs.v1.JobsService/CreateJob',
      request,
      metadata || {},
      methodDescriptor_JobsService_CreateJob);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.jobs.v1.UpdateJobRequest,
 *   !proto.acompanha.jobs.v1.UpdateJobResponse>}
 */
const methodDescriptor_JobsService_UpdateJob = new grpc.web.MethodDescriptor(
  '/acompanha.jobs.v1.JobsService/UpdateJob',
  grpc.web.MethodType.UNARY,
  proto.acompanha.jobs.v1.UpdateJobRequest,
  proto.acompanha.jobs.v1.UpdateJobResponse,
  /**
   * @param {!proto.acompanha.jobs.v1.UpdateJobRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.jobs.v1.UpdateJobResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.jobs.v1.UpdateJobRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.jobs.v1.UpdateJobResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.jobs.v1.UpdateJobResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.jobs.v1.JobsServiceClient.prototype.updateJob =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.jobs.v1.JobsService/UpdateJob',
      request,
      metadata || {},
      methodDescriptor_JobsService_UpdateJob,
      callback);
};


/**
 * @param {!proto.acompanha.jobs.v1.UpdateJobRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.jobs.v1.UpdateJobResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.jobs.v1.JobsServicePromiseClient.prototype.updateJob =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.jobs.v1.JobsService/UpdateJob',
      request,
      metadata || {},
      methodDescriptor_JobsService_UpdateJob);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.jobs.v1.DeleteJobRequest,
 *   !proto.acompanha.common.v1.SuccessResponse>}
 */
const methodDescriptor_JobsService_DeleteJob = new grpc.web.MethodDescriptor(
  '/acompanha.jobs.v1.JobsService/DeleteJob',
  grpc.web.MethodType.UNARY,
  proto.acompanha.jobs.v1.DeleteJobRequest,
  acompanha_common_v1_common_pb.SuccessResponse,
  /**
   * @param {!proto.acompanha.jobs.v1.DeleteJobRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  acompanha_common_v1_common_pb.SuccessResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.jobs.v1.DeleteJobRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.common.v1.SuccessResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.common.v1.SuccessResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.jobs.v1.JobsServiceClient.prototype.deleteJob =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.jobs.v1.JobsService/DeleteJob',
      request,
      metadata || {},
      methodDescriptor_JobsService_DeleteJob,
      callback);
};


/**
 * @param {!proto.acompanha.jobs.v1.DeleteJobRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.common.v1.SuccessResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.jobs.v1.JobsServicePromiseClient.prototype.deleteJob =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.jobs.v1.JobsService/DeleteJob',
      request,
      metadata || {},
      methodDescriptor_JobsService_DeleteJob);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.jobs.v1.PrinterStatsRequest,
 *   !proto.acompanha.jobs.v1.PrinterStatsResponse>}
 */
const methodDescriptor_JobsService_PrinterStats = new grpc.web.MethodDescriptor(
  '/acompanha.jobs.v1.JobsService/PrinterStats',
  grpc.web.MethodType.UNARY,
  proto.acompanha.jobs.v1.PrinterStatsRequest,
  proto.acompanha.jobs.v1.PrinterStatsResponse,
  /**
   * @param {!proto.acompanha.jobs.v1.PrinterStatsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.jobs.v1.PrinterStatsResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.jobs.v1.PrinterStatsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.jobs.v1.PrinterStatsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.jobs.v1.PrinterStatsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.jobs.v1.JobsServiceClient.prototype.printerStats =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.jobs.v1.JobsService/PrinterStats',
      request,
      metadata || {},
      methodDescriptor_JobsService_PrinterStats,
      callback);
};


/**
 * @param {!proto.acompanha.jobs.v1.PrinterStatsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.jobs.v1.PrinterStatsResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.jobs.v1.JobsServicePromiseClient.prototype.printerStats =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.jobs.v1.JobsService/PrinterStats',
      request,
      metadata || {},
      methodDescriptor_JobsService_PrinterStats);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.jobs.v1.ListJobsByPrinterRequest,
 *   !proto.acompanha.jobs.v1.ListJobsResponse>}
 */
const methodDescriptor_JobsService_ListJobsByPrinter = new grpc.web.MethodDescriptor(
  '/acompanha.jobs.v1.JobsService/ListJobsByPrinter',
  grpc.web.MethodType.UNARY,
  proto.acompanha.jobs.v1.ListJobsByPrinterRequest,
  proto.acompanha.jobs.v1.ListJobsResponse,
  /**
   * @param {!proto.acompanha.jobs.v1.ListJobsByPrinterRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.jobs.v1.ListJobsResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.jobs.v1.ListJobsByPrinterRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.jobs.v1.ListJobsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.jobs.v1.ListJobsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.jobs.v1.JobsServiceClient.prototype.listJobsByPrinter =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.jobs.v1.JobsService/ListJobsByPrinter',
      request,
      metadata || {},
      methodDescriptor_JobsService_ListJobsByPrinter,
      callback);
};


/**
 * @param {!proto.acompanha.jobs.v1.ListJobsByPrinterRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.jobs.v1.ListJobsResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.jobs.v1.JobsServicePromiseClient.prototype.listJobsByPrinter =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.jobs.v1.JobsService/ListJobsByPrinter',
      request,
      metadata || {},
      methodDescriptor_JobsService_ListJobsByPrinter);
};


module.exports = proto.acompanha.jobs.v1;

